import { useState } from 'react'

import { CardExpiryElement } from '@stripe/react-stripe-js'

// interface StripeCardExpiryInputProps {
//   onChange?: (event: StripeCardExpiryElementChangeEvent, error: string | undefined) => void
//   className?: string
// }

const StripeCardExpiryInput = ({ onChange, className }) => {
  const [error, setError] = useState();

  const inputStyle = {
    fontFamily:
      'sans-serif',
    fontStyle: 'normal',
    fontWeight: '400',
    fontSize: '16px',
    color: '#363741',
    width: '-webkit-fill-available',
    '::placeholder': {
      color: '#898A93'
    },
    backgroundColor: '#FFFFFF',
  }
  const mainStyle = {
    fontSize: '16px',
    padding: '10px',
    borderRadius: '5px',
    border: '1px solid var(--text-primary-800)',
    width:' -webkit-fill-available',
    backgroundColor: '#FFFFFF',
  }
  return (
    <div aria-invalid={!!error} className={className}>
      <div>
        <div
        style={mainStyle}>
          <CardExpiryElement
            onChange={event => {
              setError(event?.error?.message)
              onChange?.(event, event?.error?.message)
            }}
            options={{
              style: {
                base: inputStyle
              }
            }}
          />
        </div>
        {error && <p className={`text12Regular text-red-600`}>{error}</p>}
      </div>
    </div>
  )
}

export default StripeCardExpiryInput